import {
  createTranslatedMessageComponent,
  createUseTranslateMessage,
  useSafeIntl,
} from '@bloomberg/media.i18n';

import labelIds from './label_ids.json';

export const useTranslateMessage = createUseTranslateMessage(labelIds);
export const TranslatedMessage = createTranslatedMessageComponent(labelIds);
export const useIntl = useSafeIntl;
